/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint array-element-newline: ["error", "never"] */
import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

const handleOnClick = (event, onChange) => {
    const { target } = event;
    if (target.selectionEnd <= 2 && target.selectionend <= 2) {
        target.setSelectionRange(2, 2);
    } else {
        const valueSelected = target.value.substring(0, target.selectionEnd || target.selectionend);
        const match = valueSelected.match(/\d/gi);
        if (match) {
            const lastDigitIndexInSelection = valueSelected.lastIndexOf(match[match.length - 1]) + 1;
            target.setSelectionRange(
                lastDigitIndexInSelection,
                lastDigitIndexInSelection,
            );
        }
    }
    if (onChange) {
        onChange(event);
    }
};
const PhoneMask = (props) => {
    const { inputRef, onChange, ...other } = props;
    return (
        <MaskedInput
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[
                '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,
            ]}
            placeholderChar={'\u2000'}
            onChange={(event) => handleOnClick(event, onChange)}
        />
    );
};
PhoneMask.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default PhoneMask;
